import React, { useEffect, useState } from "react";
import { StatsProps } from "@usereactify/search";

export type FilterStatsProps = React.ComponentProps<
  NonNullable<StatsProps["render"]>
>;

export const FilterStats: React.FC<FilterStatsProps> = (props) => {

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const numberOfResults = props?.resultStats?.numberOfResults;
    if (numberOfResults) {
      setIsLoading(true);
    }

  }, [props])

  return (
    <>
      {
        isLoading ?
          <div className="filter__counts">
            {"Showing "}
            {props.resultStats.numberOfResults}
            {" products"}
          </div>
        :
          null
      }
    </>
  );
};
